import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FormHelperService, AuthService, AppSettingsService } from "../core/services";
import { CustomValidators } from "ng2-validation/dist";
import { Router } from '@angular/router';

@Component({
    moduleId: module.id,
    templateUrl: 'forgot-password.component.html'
})

export class ForgotPasswordComponent implements OnInit {
    ValidationMessages: any = {};
    forgotPasswordForm: FormGroup;
    showInvalidEmailMessage: boolean;
    showEmailSentMessage: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private formHelperService: FormHelperService,
        private authService: AuthService,
        private appSettingsService: AppSettingsService,
        private router: Router) { }

    ngOnInit() {
        this.forgotPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.maxLength(50), CustomValidators.email]],
        });
    }

    sendResetLink(event) {
        event.preventDefault();
        if (!this.forgotPasswordForm.valid)
            return;

        this.showInvalidEmailMessage = false;
        this.authService.sendForgotPassword(this.forgotPasswordForm.value.email).subscribe((resp) => {
            this.showEmailSentMessage = true;
        }, (error: any) => this.showInvalidEmailMessage = true);
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.forgotPasswordForm, controlName, validator)
    }

     onLogin(event){
        event.preventDefault();
        event.stopPropagation();
        this.router.navigate([this.appSettingsService.LoginPath]);
    }
}


// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts